import { useState } from "react";
import PreferenceTile from "./PreferenceTile.component";
import { Link } from "react-router-dom";
import { FullWidthLine } from "../../../shared";
import { AiOutlineLeft } from "react-icons/ai";
import { useNavigate, useRevalidator } from "react-router-dom";

const data = {
  plan: [
    {
      info: "I want the flexibility to go to any doctor or facility, even if it means paying more out-of-pocket.",
    },
    {
      info: "I am okay with a set network of doctors and facilities, with a lower out-of-pocket cost.",
    },
    {
      info: "I have no preference.",
    },
  ],
  benefit: [
    {
      title: "Higher FLEX Allowance",
      info: "Spending allowance that can be used toward vision, dental, hearing, acupuncture, chiropractic and podiatry.",
    },
    {
      title: "Higher over-the-counter allowance",
      info: "Spending allowance that can be used for over-the-counter (OTC) medications at participating retailers and pharmacies in-person and online.",
    },
    {
      title: "Lower maximum out-of-pocket cost",
      info: "This is the maximum amount you’ll pay for covered medical services per year.",
    },
    {
      title: "I have no preference",
      info: "",
    },
  ],
};

const PreferencesPart = () => {
  const navigate = useNavigate();
  const revalidator = useRevalidator();
  const [activeChoosingPlan, setActiveChoosingPlan] = useState<number | null>(
    null
  );
  const [activeChoosingBenefit, setActiveChoosingBenefit] = useState<
    number | null
  >(null);

  const handlePreferencePlan = (index: any) => {
    setActiveChoosingPlan(index);
  };
  const handlePreferenceBeneft = (index: any) => {
    setActiveChoosingBenefit(index);
  };

  const goContinue = () => {
    switch (activeChoosingPlan) {
      case 0:
        sessionStorage.setItem("isHMO", "false");
        sessionStorage.setItem("isPPO", "true");
        break;
      case 1:
        sessionStorage.setItem("isHMO", "true");
        sessionStorage.setItem("isPPO", "false");
        break;
    }

    switch (activeChoosingBenefit) {
      case 0:
        sessionStorage.setItem("sort", "Higher FLEX Allowance");
        break;
      case 1:
        sessionStorage.setItem("sort", "Higher Over-the-Counter Allowance");
        break;
      case 2:
        sessionStorage.setItem("sort", "Lower Maximum Out-of-Pocket Cost");
        break;
    }

    revalidator.revalidate();
    navigate("/get-recommendations/add-your-doctors");
  };

  return (
    <div className="grid-container">
      <div className="show-for-small-only">
        <h2
          style={{
            fontSize: 39,
            fontWeight: 600,
            lineHeight: "42px",
            textTransform: "uppercase",
            color: "#003A5D",
            paddingTop: 56,
            paddingBottom: 8,
          }}
        >
          Preferences
        </h2>
        <div>
          <div className="cell small-12">
            <p
              style={{
                color: "#212126",
                fontSize: 25,
                fontWeight: 500,
                lineHeight: "27px",
              }}
            >
              Select your priority when choosing a plan.
            </p>
            {data.plan.map((pre, index) => (
              <PreferenceTile
                data={pre}
                key={index}
                activeChoosingPlan={activeChoosingPlan}
                optionNumber={index}
                onClick={() => handlePreferencePlan(index)}
              />
            ))}
          </div>
        </div>
        <div className="cell small-12">
          <div
            style={{
              color: "#212126",
              fontSize: 25,
              fontWeight: 400,
              lineHeight: "32px",
              paddingTop: 48,
            }}
          >
            What would most benefit you?
          </div>
          {data.benefit.map((pre, index) => (
            <PreferenceTile
              data={pre}
              key={index}
              activeChoosingPlan={activeChoosingBenefit}
              optionNumber={index}
              onClick={() => handlePreferenceBeneft(index)}
            />
          ))}
        </div>
      </div>
      <div
        className="hide-for-small-only"
        style={{ padding: "56px 100px 39px 100px" }}
      >
        <h3
          style={{
            fontSize: 39,
            fontWeight: 600,
            lineHeight: "42px",
            textTransform: "uppercase",
            color: "#003A5D",
          }}
        >
          Preferences
        </h3>
        <div>
          <div className="cell small-12">
            <p
              style={{
                color: "#212126",
                fontSize: 25,
                fontWeight: 500,
                lineHeight: "27px",
                paddingTop: 8,
              }}
            >
              Select your priority when choosing a plan.
            </p>
            {data.plan.map((pre, index) => (
              <PreferenceTile
                data={pre}
                key={index}
                activeChoosingPlan={activeChoosingPlan}
                optionNumber={index}
                onClick={() => handlePreferencePlan(index)}
              />
            ))}
          </div>
        </div>
        <div className="cell small-12">
          <div
            style={{
              color: "#212126",
              fontSize: 25,
              fontWeight: 400,
              lineHeight: "32px",
              paddingTop: 88,
            }}
          >
            What would most benefit you?
          </div>
          {data.benefit.map((pre, index) => (
            <PreferenceTile
              data={pre}
              key={index}
              activeChoosingPlan={activeChoosingBenefit}
              optionNumber={index}
              onClick={() => handlePreferenceBeneft(index)}
            />
          ))}
        </div>
      </div>
      <FullWidthLine />
      <div
        className="hide-for-small-only"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "24px 0",
        }}
      >
        <Link
          to={{
            pathname: "/get-recommendations/coverage",
          }}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: 25,
              fontWeight: 500,
              lineHeight: "24px",
              textDecoration: "underline",
              color: "#1B54C2",
            }}
          >
            <AiOutlineLeft style={{ marginRight: "5px" }} />
            Previous step
          </div>
        </Link>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Link
            to={{
              pathname: "/get-recommendations/add-your-doctors",
            }}
          >
            <div
              style={{
                fontSize: 25,
                fontWeight: 500,
                lineHeight: "24px",
                textDecoration: "underline",
                color: "#1B54C2",
                paddingRight: 25,
                cursor: "pointer",
              }}
            >
              Skip this step
            </div>
          </Link>
          <button
            type="button"
            disabled={
              activeChoosingPlan === null || activeChoosingBenefit === null
            }
            style={{
              margin: 0,
              backgroundColor:
                activeChoosingPlan === null || activeChoosingBenefit === null
                  ? "#CACACA"
                  : "",
            }}
            className="button"
            onClick={goContinue}
          >
            Continue
          </button>
        </div>
      </div>
      <div
        className="show-for-small-only"
        style={{ paddingTop: 24, paddingBottom: 40 }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Link
            to={{
              pathname: "/get-recommendations/add-your-doctors",
            }}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              textDecoration: "underline",
              color: "#1B54C2",
              paddingRight: 25,
              cursor: "pointer",
              width: "50%",
              fontSize: 18,
            }}
          >
            Skip this step
          </Link>
          <button
            type="button"
            disabled={
              activeChoosingPlan === null || activeChoosingBenefit === null
            }
            style={{
              margin: 0,
              width: "50%",
              backgroundColor:
                activeChoosingPlan === null || activeChoosingBenefit === null
                  ? "#CACACA"
                  : "",
            }}
            className="button"
            onClick={goContinue}
          >
            Continue
          </button>
        </div>
        <Link
          to={{
            pathname: "/get-recommendations/coverage",
          }}
          style={{ textDecoration: "none" }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 32,
              fontSize: 18,
              fontWeight: 500,
              lineHeight: "24px",
              textDecoration: "underline",
              color: "#1B54C2",
            }}
          >
            <AiOutlineLeft style={{ marginRight: "5px" }} />
            Previous step
          </div>
        </Link>
      </div>
    </div>
  );
};

export default PreferencesPart;
